<template>
  <LvStateSort :list="list" :titleKey="titleKey"/>
</template>
<script>

export default {
  props: {
    list: {
      type: Array,
    },
    titleKey: {
      type: String,
      default: 'name',
    }
  },
};
</script>